export const getJdUrl = (
  jobData: jobDescriptionType | jobDataType,
  domain: string,
) => {
  const jobExpValue = () => {
    const { minimumExperience, maximumExperience } = jobData;
    if (maximumExperience?.years) {
      return `${minimumExperience?.years || 0}-${maximumExperience.years}`;
    }
    return "Fresher";
  };

  const removeSpecialChars = (
    str: string | undefined,
    excludechars: string,
  ) => {
    let filteredString = str || "";
    const specialChars = new Set("\"!@#$^&%*()+=-[]/{}|:;<>?,._�Â¿Ã~`–'");
    const excludeSet = new Set(excludechars || []);

    // Remove backslashes
    filteredString = filteredString.replace(/\\/g, "");

    // Remove excluded characters from specialChars
    excludeSet.forEach((char) => specialChars.delete(char));

    // Create a regex pattern from the remaining special characters
    const specialCharsPattern = new RegExp(
      `[${Array.from(specialChars).join("\\")}]`,
      "g",
    );

    // Replace special characters with a space
    filteredString = filteredString.replace(specialCharsPattern, " ");

    return filteredString;
  };

  const setCookie = (
    name: string,
    value: string,
    days: number,
    domain: string,
  ) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
      name + "=" + (value || "") + ";domain=" + domain + expires + "; path=/";
  };

  const setSplCookie = (val: string) => {
    if (val) {
      const domain = window.location.host.split(".").slice(-2).join(".");
      setCookie("SPL", val, 1, domain);
    }
  };

  const sanitizeString = (str: string, excludeChars = "") => {
    const sanitized = removeSpecialChars(str, excludeChars);
    return sanitized
      .replace(/,/g, " ")
      .replace(/\s\s+/g, " ")
      .trim()
      .replace(/ /g, "-")
      .replace(/--+/g, "-")
      .toLowerCase();
  };

  const _location = sanitizeString(
    (typeof jobData.locations !== "string" &&
      jobData.locations?.map(
        (location: locationsType) =>
          location.city || location.state || location.country,
      )[0]) ||
      "" ||
      "",
    "",
  );
  const _jobTitle = sanitizeString(jobData.title || "", "-");
  const _companyName = sanitizeString(jobData.companyName || "", "-");
  const _experience = sanitizeString(jobExpValue() || "", "-");

  const iscjt = jobData?.isCJT;
  const isJobType = jobData?.jobTypes
    ? jobData?.jobTypes.includes("SJS")
    : false;

  const url =
    `${_jobTitle}-${_companyName}-${_location}-${(_experience && iscjt !== 0) || isJobType ? `${_experience}-years` : ""}`.replace(
      /-$/,
      "",
    );

  const searchParams = new URLSearchParams(window.location.search);
  const spl = searchParams.get("spl") || "";
  if (isJobType) {
    if (!spl) {
      searchParams.set("spl", "MSJ_OnSite");
    }

    setSplCookie(spl);
    return `https://${domain}/job-vacancy-${url}${jobData?.kiwiJobId}.html?${searchParams.toString()}`;
  }

  if (iscjt) {
    setSplCookie(spl);
    return `https://www.foundit.in/seeker/cjt/job-vacancy-${url}-${jobData?.kiwiJobId}?${searchParams.toString()}`;
  } else if ("seoJdUrl" in jobData && jobData.seoJdUrl) {
    const jdUrl = `/${jobData.seoJdUrl.substring(1)}`;
    return jdUrl + `?${searchParams.toString()}`;
  } else {
    return `https://${domain}/job/${url}-${jobData?.id}?${searchParams.toString()}`;
  }
};
